import { getTeamsApi } from "@/components/Teams/service/api";
import { useTeamStore } from "@/store/modules";

export async function loadTeams() {
  const teamStore = useTeamStore();
  const response = await getTeamsApi(100, 0);

  const teams = Array.isArray(response?.data?.results) ? response?.data?.results : [];

  teamStore.setAllTeams(teams);

  const myTeam = teams.find((item) => item?.role?.codename === "owner") || teams[0] || null;

  teamStore.setMyTeam(myTeam);

  return teams;
}
